import { render, staticRenderFns } from "./allocation-edition.vue?vue&type=template&id=7f706657&scoped=true&"
import script from "./allocation-edition.vue?vue&type=script&lang=js&"
export * from "./allocation-edition.vue?vue&type=script&lang=js&"
import style0 from "./allocation-edition.vue?vue&type=style&index=0&lang=css&"
import style1 from "./allocation-edition.vue?vue&type=style&index=1&id=7f706657&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f706657",
  null
  
)

export default component.exports